<template>
    <div class="postBackList" id="postBackList">
        <sideBar/>

        <div class="content-body-container col-md-8" style="text-align: left;">
            <div class="postback-header-container" style="margin-bottom: 20px;">
                <h4>Postback List</h4>
            </div>

            <div class="postback-content-container">
                <div class="selected-event" style="position: relative;">
                    <select v-model="selectedEventID" placeholder="Please select event name" style="margin-bottom: 20px; background: #f7f7f7;"
                               class="w-100 form-control" @change="changeSelectedEvent()">
                        <option v-for="eventItem in eventList"
                                   class="ddlEndResultEventOption"
                                   :key="eventItem.EventID"
                                   :label="eventItem.EventTitle + ' ('+convertDatetimeFormat(eventItem.EventStartTime)+')'"
                                   :value="eventItem.EventID" style="max-width: 100%">
                        </option>
                    </select>
                </div>

                <div class="selected-postback-list" v-if="eventGroupPostBackList.length > 0">
                    <div>
                        <el-button class="el-button--primary" @click="downloadAsZip()">Download All</el-button>
                    </div>

                    <div v-for="(eachPbList, pbIndex) in eventGroupPostBackList">
                        <el-collapse v-model="accordionName" accordion style="font-size: 25px;">
                            <el-collapse-item :title="eachPbList.Str_Display"
                                              :name="pbIndex.toString()">
                                <div>
                                    <el-button class="el-button--primary" @click="downloadEach(eachPbList.Str_SortBy)">Download creator's files</el-button>
                                </div>

                                <div class="each-parent-pb" v-for="objItem in eachPbList.ArrObj_Items">
                                    <div>
                                        <p class="common-p">Created on: {{convertDatetime(objItem.EventPbCreatedOn)}}</p>
                                    </div>

                                    <div>
                                        <p class="common-p">Remarks: {{objItem.EventPbRemarks}}</p>
                                    </div>

                                    <div v-if="objItem.pbAllFiles.length > 0">
                                        <p class="common-p">Files list: </p>

                                        <div v-for="objFiles in objItem.pbAllFiles">
                                            - <a :href="getFile(objFiles)" :download="`${objFiles.EventPbfFileName}`" class="filepath">
                                            {{objFiles.EventPbfFileName}}
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                        <!--                        <div>-->
                        <!--                            <p class="common-p">Created by: {{eachPbList.Str_Display}}</p>-->
                        <!--                        </div>-->

                        <!--                        <div class="each-parent-pb" v-for="objItem in eachPbList.ArrObj_Items">-->
                        <!--                            <div>-->
                        <!--                                <p class="common-p">Created on: {{convertDatetime(objItem.EventPbCreatedOn)}}</p>-->
                        <!--                            </div>-->

                        <!--                            <div>-->
                        <!--                                <p class="common-p">Remarks: {{objItem.EventPbRemarks}}</p>-->
                        <!--                            </div>-->

                        <!--                            <div v-if="objItem.pbAllFiles.length > 0">-->
                        <!--                                <p class="common-p">Files list: </p>-->

                        <!--                                <div v-for="objFiles in objItem.pbAllFiles">-->
                        <!--                                    - <a :href="getFile(objFiles)" :download="`${objFiles.EventPbfFileName}`" class="filepath">-->
                        <!--                                        {{objFiles.EventPbfFileName}}-->
                        <!--                                    </a>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                </div>
            </div>

            <div class="empty-list_image" v-if="eventPostBackList.length <= 0">
                <strong>{{empty_message}}</strong>
                <img src="../assets/notfound.png"/>
            </div>
        </div>

    </div>
</template>

<script>
    "use strict";
    import DataSource from "../data/datasource";
    import sideBar from "../components/Sidebar";
    import {lang} from '../locale/index';
    import $ from 'jquery';
    import Cookies from "js-cookie";
    import moment from 'moment';

    export default {
        name: "EventPostBack",
        components: {
            sideBar,
        },
        data() {
            return {
                eventList: [],
                eventPostBackList: [],
                eventGroupPostBackList: [],
                selectedEventID: '',
                selectedDisplayMode: 'NonParent', // NonParent <- get all record, Parent <- get only specific record

                empty_message: 'No Record',
                accordionName: '',
                allPBIDs: [],
            };
        },
        methods: {
            lang,
            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },

            changeSelectedEvent() {
                this.loadEventPostback();
            },

            async loadEventPostback() {
                this.$vs.loading();

                try {
                    let response = await DataSource.shared.getEventPostBack(this.selectedEventID, this.selectedDisplayMode);

                    if (response) {
                        if (response.code === '99') {
                            console.log(response.code);
                            return;
                        }

                        if (response.code === '88') {
                            window.location.replace('/');
                            return;
                        }

                        // EventPbRemarks, CONname, EventPbCreatedOn,
                        if (response.Table) {

                            response.Table.forEach(pbItem => {
                                let pbFiles = DataSource.shared.getEventPostBackFile(pbItem.EventPbID);

                                this.allPBIDs.push(pbItem.EventPbID);

                                pbItem.pbAllFiles = [];
                                pbFiles.then((pbFiles) => {
                                    if (pbFiles.Table) {
                                        pbItem.pbAllFiles = pbFiles.Table;
                                    }
                                });
                            });

                            this.eventPostBackList = response.Table;

                            let sortedList = this.groupBy(this.eventPostBackList, "EventPbCreatedBy", "CONname");

                            this.eventGroupPostBackList = sortedList;
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e);
                }
            },

            groupBy(data, key, display) {
                let ArrObj_Sorted = [];
                let arrstr_display = !this.isNull(display) ? display.split(",") : [key];

                for (let item of data) {
                    let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);

                    if (index === -1) {
                        let str_Display = "";
                        for (let tempdisp of arrstr_display)
                            str_Display += item[tempdisp] + " ";

                        ArrObj_Sorted.push({Str_SortBy: item[key], Str_Display: str_Display, ArrObj_Items: [item]});
                    } else
                        ArrObj_Sorted[index].ArrObj_Items.push(item);
                }

                return ArrObj_Sorted;
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },

            getFile(file) {
                return `data:${file.EventPbfFileType};base64,${file.EventPbfItem}`;
            },

            convertDatetime(datetimeVal) {
                return moment(datetimeVal).format("DD MMM YYYY HH:mm:ss");
            },

            convertDatetimeFormat(datetimeVal) {
                return moment(datetimeVal).format("DD/MM/YYYY HH:mm:ss");
            },

            async downloadEach(createdBy) {
                try {
                    this.$vs.loading();

                    const resp = await DataSource.shared.getAllEventPostBackZipFile(this.selectedEventID, createdBy);

                    if (response.code === '88') {
                        window.location.replace('/');
                        return;
                    }

                    if (resp.code === '99') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Cannot download files!'
                        });
                    } else {
                        let byteChar = atob(resp.code);
                        let byteNo = new Array(byteChar.length);
                        for (let i = 0; i < byteChar.length; i++) {
                            byteNo[i] = byteChar.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNo);
                        let file = new Blob([byteArray], {type: 'application/zip;base64'});
                        let fileUrl = URL.createObjectURL(file);
                        window.location.href = fileUrl;
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e, "zip error msg!");
                }
            },

            async downloadAsZip() {
                try {
                    this.$vs.loading();

                    const resp = await DataSource.shared.getAllEventPostBackZipFile(this.selectedEventID, "");
                    // console.log(resp, "resp");

                    if (response.code === '88') {
                        window.location.replace('/');
                        return;
                    }

                    if (resp.code === '99') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Cannot download files!'
                        });
                    } else {
                        let byteChar = atob(resp.code);
                        let byteNo = new Array(byteChar.length);
                        for (let i = 0; i < byteChar.length; i++) {
                            byteNo[i] = byteChar.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNo);
                        let file = new Blob([byteArray], {type: 'application/zip;base64'});
                        let fileUrl = URL.createObjectURL(file);
                        window.location.href = fileUrl;
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e, "zip error msg!");
                }
            },
        },
        created() {
            window.addEventListener('resize', this.isMobile);

            this.eventList = this.$route.params.paramEventList;
        },
        destroyed  () {
            $(window).unbind('scroll');
            window.removeEventListener('resize', this.isMobile);
        },
        mounted() {
            const self = this;
            self.isMobile();

            $(document).ready(function(){
                $(".content-body-container").css("min-height", window.outerHeight);
            });

            this.schoolID = Cookies.get('schoolSession');
        },
        updated() {

        },
        computed: {

        },
    }
</script>

<style scoped>
    .content-body-container {
        display: inline-block;
        padding: 20px;
        background: white;
    }

    .each-parent-pb {
        margin: 10px 0px;
        padding: 0px 20px;
    }

    .common-p {
        margin-bottom: 0px;
    }
</style>

<style>
    #postBackList .el-collapse-item__header {
        padding: 20px;
        /*border-radius: 8px 8px 0px 0px;*/
        color: #4F4F4F;
        background: aliceblue;

        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px!important;
        line-height: 19px;
    }
</style>